import {
  DeleteCompanyModal,
  InvoiceAndGiftCardAndClubParisModal,
  NeedInvoiceModal
} from '../payment-methods';
import { CencoPayModal } from '../payment-methods/components/cencopay';
import { ChangePaymentMethod } from '../payment-methods/components/cencopay/components/modals/change-payment-method-modal';
import { CencopayGetTheAppModal } from '../payment-methods/components/cencopay/components/modals/get-the-app-modal';
import { InvoiceAndGuestModal } from '../payment-methods/components/need-invoice/invoice-and-guest-modal.component';

export const PaymentModals = () => (
  <>
    <NeedInvoiceModal />
    <DeleteCompanyModal />
    <InvoiceAndGiftCardAndClubParisModal />
    <CencoPayModal />
    <ChangePaymentMethod />
    <CencopayGetTheAppModal />
    <InvoiceAndGuestModal />
  </>
);
